var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WingBlank',[_c('WhiteSpace'),_vm._v(" "),_c('Button',{attrs:{"onClick":_vm.listView}},[_vm._v("ListView")]),_vm._v(" "),_c('WhiteSpace'),_vm._v(" "),_c('Button',{attrs:{"onClick":_vm.indexList}},[_vm._v("索引列表（标题吸顶）")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde9da2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ListViewNav.vue
// module id = null
// module chunks = 